export function sleep(milliseconds: number, reason: string): Promise<string> {
    return new Promise((resolve) =>
        setTimeout(() => {
            resolve(reason);
        }, milliseconds)
    );
}
